import { __awaiter, __extends, __generator } from "tslib";
import { ProductsApi } from '../../apis/ProductsApi/ProductsApi';
import { BaseActions } from '../BaseActions';
var ProductActions = /** @class */ (function (_super) {
    __extends(ProductActions, _super);
    function ProductActions(_a) {
        var siteStore = _a.siteStore, origin = _a.origin;
        var _this = _super.call(this, { siteStore: siteStore, origin: origin }) || this;
        _this.productsApi = new ProductsApi({ siteStore: siteStore, origin: origin });
        return _this;
    }
    ProductActions.prototype.fetchExtendedProductBySlug = function (slug) {
        // todo fed ops
        // todo bi
        return this.productsApi.fetchExtendedProductBySlug(slug);
    };
    ProductActions.prototype.fetchDefaultProduct = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.productsApi.fetchDefaultProduct()];
            });
        });
    };
    return ProductActions;
}(BaseActions));
export { ProductActions };
//# sourceMappingURL=ProductActions.js.map